export const EVENT_COLLECTION_MODELS = {
  SERVICE_FEE_ONLY: "sportyaServiceFeeOnly",
  COLLECTS_TOTAL: "sportyaCollectsTotal",
}

export const EVENT_PRICE_KEYS = ["free", "freeDiscounted", "premium"]

const money = value => Math.round((Number(value) + Number.EPSILON) * 100) / 100

export const prepareCompetitionFee = fee => {
  const allocation = fee?.economicAllocation
  return {
    ...fee,
    collectionModel:
      allocation?.collectionModel || "",
    eventServiceFeeAllocation: Object.fromEntries(EVENT_PRICE_KEYS.map(key => [
      key,
      allocation?.prices?.[key]?.eventServiceFee ?? Number(fee?.[key] || 0),
    ])),
  }
}

export const buildCompetitionFee = (fee, country) => {
  const collectionModel = fee?.collectionModel
  if (collectionModel && !Object.values(EVENT_COLLECTION_MODELS).includes(collectionModel)) {
    throw new Error("EVENT_COLLECTION_MODEL_REQUIRED")
  }

  const competitionFee = {
    country: country.key,
    currency: country.currency,
    localCurrency: country.localCurrency,
    free: money(fee?.free || 0),
    freeDiscounted: money(fee?.freeDiscounted || 0),
    premium: money(fee?.premium || 0),
    clubEntryFee: money(fee?.clubEntryFee || 0),
  }

  if (!collectionModel) return competitionFee

  const prices = Object.fromEntries(EVENT_PRICE_KEYS.map(key => {
    const playerCharge = money(fee?.[key] || 0)
    const eventServiceFee = collectionModel === EVENT_COLLECTION_MODELS.SERVICE_FEE_ONLY
      ? playerCharge
      : money(fee?.eventServiceFeeAllocation?.[key])
    if (!Number.isFinite(eventServiceFee) || eventServiceFee < 0 || eventServiceFee > playerCharge) {
      throw new Error(`INVALID_EVENT_SERVICE_FEE_ALLOCATION_${key}`)
    }
    return [key, {
      eventServiceFee,
      clubPayable: collectionModel === EVENT_COLLECTION_MODELS.COLLECTS_TOTAL
        ? money(playerCharge - eventServiceFee)
        : 0,
      clubCollectedDirect: collectionModel === EVENT_COLLECTION_MODELS.SERVICE_FEE_ONLY
        ? money(fee?.clubEntryFee || 0)
        : 0,
      clubCollectedDirectCurrency: country.localCurrency,
    }]
  }))

  return {
    ...competitionFee,
    economicAllocation: { version: 1, collectionModel, prices },
  }
}
